module.exports = __webpack_public_path__ + "img/satrindo_mitra_utama.23b76bbd.png";